import { API_URL } from "../../constans/roles";
import { fetchJson } from "../fetch";

export const loginUser = async (login, password) =>
  fetchJson(`${API_URL}/api/user/login`, {
    method: "POST",
    reqToken: false,
    body: { login, password },
  });

export const registerUser = async (payload) =>
  fetchJson(`${API_URL}/api/user/register`, {
    method: "POST",
    body: payload,
  });

export const getUserProfile = async () =>
  fetchJson(`${API_URL}/api/user/name`, {
    method: "GET",
  });
